import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, withCtx as _withCtx, createSlots as _createSlots } from "vue"

import { ref } from "vue";
import { t } from "@/plugins/vue-i18n";

import ButtonSliding from "@/components/button/ButtonSliding.vue";
import ScanDetailsEntry from "@/components/various/ScanDetailsEntry.vue";
import SliderOptionDeleteBoxed from "@/components/sliderOptions/SliderOptionDeleteBoxed.vue";
import SliderOptionAmount from "@/components/sliderOptions/SliderOptionAmount.vue";

import { useListStore } from "@/stores/lists";
import { useUserStore } from "@/stores/user";

import { replaceToast } from "@/functions/baseToast";
import { popAlertConfirm } from "@/functions/alert";

import { CatalogItem } from "@/types/supplier";
import { PERMISSION_KEY } from "@/types/user";

interface ScanDetailsSliding {
    entry: CatalogItem;
    listId: string;
    edit?: boolean;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ScanDetailsSliding',
  props: {
    entry: {},
    listId: {},
    edit: { type: Boolean }
  },
  emits: ["amount"],
  setup(__props: any, { emit: __emit }) {


const props = __props
const emit = __emit

const listStore = useListStore()
const userStore = useUserStore()

const scanDetailSlider = ref()

const handleAmount = (amount?: number): void => {
    emit('amount', amount);
}

const handleDeleteClick = (event: MouseEvent | TouchEvent): void => {
    event.stopPropagation()
    popAlertConfirm({
        message: t('alert.delete.scanProduct', { target: props.entry.name }),
        handler: {
            ok: deleteScanItem
        }
    })
}

const deleteScanItem = (): void => {
    listStore.deleteItemFromScanList(props.listId, props.entry.id)
    replaceToast({
        message: t('success.delete', { target: t('target.product') }),
        id: 'delete-list-success',
        cssClass: 'toast-offset-50'
    }, 'delete-list-success')
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ButtonSliding, {
    ref_key: "scanDetailSlider",
    ref: scanDetailSlider,
    style: {"border-bottom":"2px solid var(--ion-color-grey4)"}
  }, _createSlots({
    default: _withCtx(() => [
      _createVNode(ScanDetailsEntry, {
        class: "pt-1 pb-2 light-light-background purple-purple-color",
        entry: __props.entry,
        edit: __props.edit,
        onEdit: _cache[0] || (_cache[0] = ($event: any) => (scanDetailSlider.value.$el.open('end')))
      }, null, 8, ["entry", "edit"])
    ]),
    _: 2
  }, [
    (__props.edit)
      ? {
          name: "options-end",
          fn: _withCtx(() => [
            (_unref(userStore).permission[_unref(PERMISSION_KEY).CART_DELETE])
              ? (_openBlock(), _createBlock(SliderOptionDeleteBoxed, {
                  key: 0,
                  onClick: handleDeleteClick
                }))
              : _createCommentVNode("", true),
            (_unref(userStore).permission[_unref(PERMISSION_KEY).CART_UPDATE])
              ? (_openBlock(), _createBlock(SliderOptionAmount, {
                  key: 1,
                  modelValue: __props.entry.quantity,
                  "min-value": 1,
                  STEP_SIZE: __props.entry.amountStep,
                  "onUpdate:modelValue": handleAmount,
                  onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"]))
                }, null, 8, ["modelValue", "STEP_SIZE"]))
              : _createCommentVNode("", true)
          ]),
          key: "0"
        }
      : undefined
  ]), 1536))
}
}

})